import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATION } from '@ngrx/router-store';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { exhaustMap, map, tap, withLatestFrom } from 'rxjs/operators';
import {
   applicationVersionChangeAcknowledged,
   applicationVersionChangeAcknowledgementSkipped,
   applicationVersionChanged,
} from './app.actions';
import { AppState } from './app.reducer';
import { selectRouteData } from './app.selectors';
import { getIsLoggedIn } from './authentication/state/authentication.selector';
import { ConfirmationDialogService } from './common-components/confirmation-dialog/confirmation-dialog.service';
import { DialogSize } from './common-components/confirmation-dialog/enumerations/dialog-size.enum';
import { ConfirmationDialogType } from './common-components/confirmation-dialog/models/confirmation-dialog.config';
import { accountRoutingChange } from './store/select-account/select-account.actions';
@Injectable()
export class AppEffects {
   applicationVersionChangeAcknowledged$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(applicationVersionChangeAcknowledged, applicationVersionChangeAcknowledgementSkipped),
            tap(() => {
               // eslint-disable-next-line no-self-assign
               window.location.href = window.location.href;
            })
         );
      },
      { dispatch: false }
   );

   applicationVersionChanged$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(applicationVersionChanged),
         withLatestFrom(this.store.pipe(select(getIsLoggedIn))),
         exhaustMap(([action, isLoggedIn]) => {
            if (!isLoggedIn) {
               return of(applicationVersionChangeAcknowledgementSkipped());
            }
            return this.confirmationDialogService
               .confirm({
                  data: {
                     dialogType: ConfirmationDialogType.Ok,
                     header: 'Update',
                     message: 'A new version of NDT is available. The application must be reloaded.',
                  },
                  size: DialogSize.Medium,
               })
               .afterClosed()
               .pipe(
                  map(() => {
                     return applicationVersionChangeAcknowledged();
                  })
               );
         })
      );
   });

   updateSelectedAccount$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(ROUTER_NAVIGATION),
            withLatestFrom(this.store.pipe(select(selectRouteData))),
            tap(([_action, routeData]) => {
               this.store.dispatch(accountRoutingChange());
            })
         );
      },
      { dispatch: false }
   );

   constructor(
      private actions$: Actions,
      private store: Store<AppState>,
      private confirmationDialogService: ConfirmationDialogService
   ) {}
}
